module.exports = __webpack_public_path__ + "static/img/verify5.ccde31d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verify5.jpg
// module id = tk70
// module chunks = 0